export const getWebRoutes = {
  home: "/",
  mobileRoute: "mobile-route",
  players: "players",
  leagues: "leagues",
  matches: "matches",
  invites: "invites",
};
